import React, { useEffect, useState } from 'react';
import {
  Container,
  CircularProgress,
} from '@mui/material';
import { fetch } from '../utils/lib';
import { useAppBar } from '../providers/AppBarProvider';
import { useNavigate } from 'react-router-dom';
import HomeList from '../layouts/HomeList';
import useNavigationHelperStore from '../store/navigationHelperStore';
import { useTranslation } from 'react-i18next';


function MainHome() {

  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const {updateTitle, toggleFab} = useAppBar();
  const { setNavigation, setSelectedReport } = useNavigationHelperStore();
  const { t } = useTranslation();

  useEffect(() => {
    toggleFab(true);
    const fetchHome = async () => {
      const notifications = await fetch('users_home');
      
      // Define notification types that should not be clickable
      const nonClickableTypes = ['PROMOTED_TO_PREMIUM', 'WELCOME', 'PAYMENT_RECEIVED'];
      
      // Process notifications to mark certain types as non-clickable
      const processedNotifications = notifications.map(notification => {
        if (nonClickableTypes.includes(notification.notification_type)) {
          return { ...notification, notification_clickable: false };
        }
        return notification;
      });
      
      setNotifications(processedNotifications);
      updateTitle('', t('main.home'));
      setIsLoading(false);
    };
    fetchHome();
  }, []);

  const onClick = (notification) => {
    // console.log(notification);
    // Only allow clicks if notification_clickable is not defined or is true
    if (notification && 
        notification.notification_type && 
        (notification.notification_clickable === undefined || notification.notification_clickable === true)) {

        if (notification.notification_url) {
          //open url in new tab
          window.open(notification.notification_url, '_blank');
        } else {
          setNavigation('main/home', { });
          setSelectedReport(notification.notification_type);
          navigate('/main/reports');
        }
    }
  }

  if (isLoading) return (
    <>
      <CircularProgress
        size={42}
        sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-21px', marginLeft: '-21px' }}
      />
    </>
  );
  
  return (
    <Container
      maxWidth="xl"
      >

      <HomeList
        notifications={notifications}
        onClick={onClick}
      />

    </Container>
  );
}

export default MainHome;

